import { Alert } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import type { FC, PropsWithChildren } from "react";

export const ErrorAlert: FC<PropsWithChildren> = ({ children }) => (
  <Alert
    variant="light"
    color="red"
    icon={<IconExclamationCircle />}
    styles={{
      wrapper: {
        alignItems: "center",
      },
      root: {
        overflow: "visible",
      },
    }}
  >
    {children}
  </Alert>
);
